/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：マスタ画面のコンフィグ
 *
 * 作成者：2022/2/27 ノア）黄
 * 最終修正者：2022/2/27 ノア）黄
 *
 */

import config from './config'

/**
 * マスタ画面のコンフィグ
 *
 * @constant
 */
const masterConfig: Record<string, any> = {
  /**
   * 営業所選択機能なしURL
   */
  notShowBusinessOfficeSelectorUrlList: [
    config.menu.areaAnalysis, // エリア別分析
    config.menu.chartArea, // グラフ表示(エリア別)
    config.menu.chartPrefecture, // グラフ表示(都道府県別)
    config.menu.analysisByManagementObject, // 管理対象分析
    config.menu.corporateManagement, // 会社管理
    config.menu.businessOfficeMaster, // 営業所登録マスタ
    config.menu.businessOfficeAllocation, // 営業所割当マスタ
    config.menu.userMaster, // ユーザマスタ
    config.menu.areaMaster, // エリア登録マスタ
    config.menu.areaAllocation, // エリア割当マスタ
    config.menu.subjectMasterAllocation, // 管理対象割当
    config.menu.headMaster, // トラクターヘッドマスタ
    config.menu.tractorHeadMaster // 連結可能トラクターヘッドマスタ
  ],
  /**
   * 営業所選択機能なしpageId
   */
  notShowBusinessOfficeSelectorPageIdList: [
    'MST_CO_MGMT', // 会社管理
    'MST_SALES_OFC', // 営業所登録マスタ
    'MST_SALES_OFC_ALLOC', // 営業所割当マスタ
    'MST_USER', // ユーザマスタ
    'MST_AREA', // エリア登録マスタ
    'MST_PREF_ALLOC', // エリア割当マスタ
    'MST_MGMT_TRGTS_ALLOC', // 管理対象割当
    'MST_TRCTR_HEAD', // トラクターヘッドマスタ
    'MST_AVL_TRCTR_HEAD' // 連結可能トラクターヘッドマスタ
  ]
}

export default masterConfig
